import Markdown from "react-markdown";
import { Components, PluggableList } from "react-markdown/lib";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const Code: Components["code"] = (props: any) => {
  const { node, inline, className, children, ...other } = props;

  const language = /language-(\w+)/.exec(className || "");

  return !inline && language ? (
    // <SyntaxHighlighter
    //   children={String(children).replace(/\n$/, '')}
    //   language={language[1]}
    //   PreTag="div"
    //   style={codeStyle}
    //   {...other}
    // />
    <></>
  ) : (
    <code className={className} {...other}>
      {children}
    </code>
  );
};

export const markdownComponents = {
  code: Code,
};
